import { Card, Divider } from "react-native-paper";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { CircularIconContainer } from "../CircularIconContainer";
import { TipCallout } from "../TipCallout";

type ProgressCardShellProps = {
	icon: IconType;
	title: string;
	subtitle?: string;
	headerAction?: React.ReactNode;
	tip?: string;
	fillHeight?: boolean;
	tipLoading?: boolean;
	children: React.ReactNode;
};

export const ProgressCardShell = ({
	icon,
	title,
	subtitle,
	headerAction,
	tip,
	fillHeight,
	tipLoading,
	children,
}: ProgressCardShellProps) => {
	const theme = useAppTheme();

	return (
		<FlatCard
			style={{
				height: fillHeight ? "100%" : undefined,
				overflow: "hidden",
			}}
			contentStyle={{ flex: fillHeight ? 1 : undefined }}
		>
			<Card.Title
				title={title}
				titleVariant="titleMedium"
				titleStyle={{ marginBottom: 0 }}
				subtitle={subtitle}
				subtitleVariant="bodySmall"
				subtitleNumberOfLines={0}
				left={() => (
					<CircularIconContainer
						iconName={icon}
						size={40}
						iconSize={24}
						backgroundColor={theme.colors.elevation.level1}
						iconColor={theme.colors.onSurface}
					/>
				)}
				right={headerAction ? () => headerAction : undefined}
				rightStyle={{ marginRight: 16 }}
			/>
			<Divider style={{ backgroundColor: theme.colors.surfaceVariant }} />
			<Box gap={8} flex={fillHeight ? 1 : undefined}>
				<Card.Content
					style={{
						paddingHorizontal: 0,
						paddingVertical: 0,
						flex: fillHeight ? 1 : undefined,
					}}
				>
					{children}
				</Card.Content>
				{tip || tipLoading ? (
					<Card.Content style={{ paddingTop: 0, paddingBottom: 16 }}>
						<TipCallout text={tip} isLoading={tipLoading} variant="flat" />
					</Card.Content>
				) : null}
			</Box>
		</FlatCard>
	);
};
